import {isEmpty} from 'lodash'
export function getUserColumns() {
    let columns = JSON.parse(localStorage.getItem('userColumns'))
    if (!isEmpty(columns)) {
        return columns
    }
    return ['checkbox', 'first_name', 'middle_name', 'last_name', 'email', 'settings']
}

export function getUserTableOptions() {
    return {
        filterByColumn: false,
        perPage:10,
        pagination: { show: false},
        filterable: false,
        headings: {
            first_name : 'first Name',
            middle_name: 'Middle Name',
            last_name : 'Last Name',
            email: 'Email Address'
          },
          sortable: ['no'],
          sortIcon: { base: 'as-nova', up: 'nova-tablesortinga-z', down: 'nova-tablesortingz-a', is: 'nova-tablesorting' },
    }
}
export function getUserTableSettingsOptions() {
    return [
           {key: 'checkbox', value: 'Checkbox' },
           {key: 'first_name', value: ('First Name')},
           {key: 'last_name', value: ('Last Name')},
           {key: 'middle_name', value: ('Middle Name')},
           {key: 'email', value:  ('Email Address')},
           {key: 'settings', value:  ('Settings')},
    ]
    
}